import { Button } from "@cloudscape-design/components";
import { FC } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { Customer, SalesInvoice } from "../../models/Sales";
import { useAuthContext } from "../../contexts/AuthContext";
import { SalesInvoiceDefinition } from "./DocumentDefentions";
import { convertImageUrlToBase64, fetchImageUrl } from "../../api/storage";
import { Batch } from "../../models/Batch";

(pdfMake as any).vfs = pdfFonts.vfs;

interface IPdfExportSalesInvoiceProps {
  invoice: SalesInvoice;
  customer?: Customer;
  batches: Record<string, Batch>;
}

const PdfExportSalesInvoice: FC<IPdfExportSalesInvoiceProps> = ({
  invoice,
  customer,
  batches,
}) => {
  const { tenantObject } = useAuthContext();

  const handleDownload = async () => {
    if (!tenantObject || !customer) return;

    const logoUrl = await fetchImageUrl(`logos/${tenantObject.name}/image`);
    const logo = await convertImageUrlToBase64(logoUrl);

    const doc = SalesInvoiceDefinition(
      tenantObject,
      invoice,
      batches,
      customer,
      logo ?? ""
    );

    pdfMake.createPdf(doc).download(`Invoice-${invoice.invoiceNumber}.pdf`);
  };

  return (
    <Button iconName="download" onClick={handleDownload} disabled={!invoice}>
      Download PDF
    </Button>
  );
};

export default PdfExportSalesInvoice;
